import { useState } from 'react';

import type { RangeFilter, RadioFilter } from '../types';
// eslint-disable-next-line import/no-extraneous-dependencies
import type { DateValue } from '@internationalized/date';

export type DateRangeFilter = { start: DateValue; end: DateValue };

export const useFilter = <
  T extends Record<
    string,
    boolean | number | string | string[] | undefined | Date | RangeFilter | RadioFilter | DateRangeFilter
  >
>(
  initialFilter = {} as T
) => {
  const [filter, setFilter] = useState(initialFilter);

  const isFilterActive: boolean = Object.keys(filter).reduce(
    (active: boolean, key) =>
      active || (filter[key] && Array.isArray(filter[key]) ? !!(filter[key] as string[]).length : !!filter[key]),
    false
  );

  return {
    filter,
    setFilter,
    isFilterActive,
  };
};
